import { render, staticRenderFns } from "./memberPower.vue?vue&type=template&id=1fa8782e&scoped=true"
import script from "./memberPower.vue?vue&type=script&lang=js"
export * from "./memberPower.vue?vue&type=script&lang=js"
import style0 from "./memberPower.vue?vue&type=style&index=0&id=1fa8782e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8782e",
  null
  
)

export default component.exports